import httpClient from "../utils/httpClient";

export const GetCatalogs = async () => {
    const response = await httpClient.post('/Catalog/get-catalogs', { PageSize: 1000, PageNo :1});
    return response.data;
};